import { render } from "./PreScreen.vue?vue&type=template&id=00798f9e&scoped=true"
import script from "./PreScreen.vue?vue&type=script&lang=js"
export * from "./PreScreen.vue?vue&type=script&lang=js"

import "./PreScreen.vue?vue&type=style&index=0&id=00798f9e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00798f9e"]])

export default __exports__